import { Group, NodeModel } from 'ui/workflows/flowchart/types';

export const tilesetConfig = {
  draw(_: NodeModel, group: Group) {
    group?.clear();
    return group;
  },
};
